import { trpc } from 'utils/trpc';
export const useSendCustomSlackMessage = () => {
  const customMessageToSlack = trpc.useMutation(['users.sendCustomMessageToSlack']);
  return customMessageToSlack;
};